import React, { useState, useEffect, useRef } from 'react';
import { StyledPointsModalDiv } from './index.styles';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { PointsFilter } from '.';
import {
  DefaultValue,
  SearchFacetsConstants,
  SearchFacetsList,
  SearchFacetsListCodes,
} from '../../organisms/SearchResults/index.constant';
import {
  getSearchAppliedFilter,
  getSearchFilterInitialState,
  SearchActions,
} from '../../organisms/SearchResults/store/store.action';
import {
  SearchStateExtendsType,
  SearchStateFilterObj,
  SearchFacetsResponse,
} from '../../organisms/SearchResults/store/store.type';
import clsx from 'clsx';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { Modal, useCheckBreakpoint, usePortalStyle } from '@marriott/mi-ui-library';
import { getTotalFilterCount, updateQueryParams } from '../../organisms/SearchResults/lib/helper';
import { useConditionalPageContextSERP } from '../../hooks';
import { Button } from '@marriott/mi-ui-library';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
import { MAP_VIEW_SESSION_KEY } from '../../modules/store/store.constants';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const PointsModalComponent: React.FC<{
  hideTaxesToggle: boolean;
  filterData?: Array<SearchFacetsResponse>;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ hideTaxesToggle, filterData, setFetchCurrencyConversionFactors }) => {
  const clickTrackingLoc = 'Phoenix Search Results';
  const { headersData } = useConditionalPageContextSERP();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent, setFeatureSelected, setIsTaxesandFeesIncludedFromPopup }: any =
    useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { searchQueryState, setSearchQuery, setFilterModalOpen } = useConditionalSearchFilterContextWithSerpFlag();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const [popupOpenState, setPopupOpenState] = useState(false);
  const [includeTaxes, setIncludeTaxes] = useState<boolean>(searchQueryState[SearchFacetsConstants.includeTaxes]);
  useEffect(() => {
    if (includeTaxes !== searchQueryState[SearchFacetsConstants.includeTaxes]) {
      setIncludeTaxes(searchQueryState[SearchFacetsConstants.includeTaxes]);
    }
  }, [searchQueryState[SearchFacetsConstants.includeTaxes]]);
  const [currCurrency, setCurrCurrency] = useState<string>(searchQueryState.currentCurrency);
  const [isFilterUpdate, setIsFilterUpdated] = useState<boolean>(false);

  const [filterSelectionData, setFilterSelectionData] = useState<SearchStateExtendsType | undefined | null>(
    getSearchFilterInitialState(searchQueryState)
  );

  const [currFilterData, setCurrFilterData] = useState<Array<SearchFacetsResponse> | undefined>(filterData);

  const bodyRef = useRef<HTMLBodyElement | null>(null);
  const isDesktop = useCheckBreakpoint('viewportM'); // check if viewport is desktop till 768px

  const { setContainerRef, PortalStyleProvider } = usePortalStyle();

  useEffect(() => {
    bodyRef.current = document.body as HTMLBodyElement;
  }, []);

  // Notify parent component about filter modal open/close state for body overflow control
  useEffect(() => {
    setFilterModalOpen?.(popupOpenState);
  }, [popupOpenState, setFilterModalOpen]);

  const onFilterChange = (type: SearchFacetsList, data: SearchStateFilterObj): void => {
    let arr1: SearchStateExtendsType = { ...filterSelectionData };
    if (filterSelectionData) {
      arr1[type] = data;
    } else {
      arr1 = {
        [type]: data,
      };
    }
    if (!isFilterUpdate) {
      /*** if user interact with filter */
      setIsFilterUpdated(true);
    }
    setFilterSelectionData(arr1);
    setFetchCurrencyConversionFactors(true);
    setInteractionsSelected({ ...interactionsSelected, points: true });
  };

  const applyBtnHandler = (): void => {
    const payload = filterSelectionData === undefined ? { [SearchFacetsList.points]: {} } : filterSelectionData;
    const points = payload?.[SearchFacetsList.points]
      ? Object.values(payload?.[SearchFacetsList.points] as SearchStateFilterObj)
      : [0];
    if (
      currCurrency !== searchQueryState.currentCurrency &&
      (getTotalFilterCount(payload) !== getTotalFilterCount(searchQueryState) || isFilterUpdate)
    ) {
      // in order to update the filter change with currency change we have to publish this event
      setIsFilterUpdated(false);
      eventUtil.dispatch('observeFilterChangeToUpdateTheDataWithCurrency', true);
    }
    // Update the selected filter values in the URL
    updateQueryParams(
      {
        includeTaxes,
        selectedCurrency: currCurrency,
        pointsRangeIndex: [Number(points.length >= 1 ? points[0] : 0)],
      },
      ['includeTaxes', 'selectedCurrency', 'pointsRangeIndex'],
      headersData?.referer
    );
    setSearchQuery({
      type: SearchActions.updateCurrency,
      payload: {
        currentCurrency: currCurrency,
      },
    });
    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: 0,
      },
    });
    setSearchQuery({
      type: SearchActions.updateTaxesAndAvailability,
      payload: {
        [SearchFacetsConstants.includeTaxes]: includeTaxes,
      },
    });
    setSearchQuery({ type: SearchActions.setApplyFilter, payload: payload });

    // create copy of filterSelectionData and searchQueryState to compare the values using for loop
    const pointsFilterSelectionData = filterSelectionData?.POINTS;
    const pointsFilterSearchQuery = searchQueryState[SearchFacetsList.points];

    //isFilterUpdated is used to determine if any value changed for filterSelectionData and payload
    let isFilterUpdated = false;
    if (JSON.stringify(pointsFilterSelectionData) !== JSON.stringify(pointsFilterSearchQuery)) {
      //comparing each filter data inside filterSelectionData and payload to determing if filters are changed.
      isFilterUpdated = true;
    }

    const shouldCallUXL = isFilterUpdated;

    if (shouldCallUXL) {
      setSearchQuery({
        type: SearchActions.setQuery,
        payload: {
          [SearchFacetsConstants.facets]: {
            ...getSearchAppliedFilter(payload, searchQueryState),
          },
          [SearchFacetsConstants.options]: {
            ...searchQueryState.search[SearchFacetsConstants.options],
            [SearchFacetsConstants.includeTaxes]: searchQueryState[SearchFacetsConstants.includeTaxes],
            [SearchFacetsConstants.unavailableProperties]:
              searchQueryState[SearchFacetsConstants.unavailableProperties],
          },
        },
      });
    }

    setIsTaxesandFeesIncludedFromPopup(true);
  };

  const onUpdateIncludeTax = (val: boolean): void => {
    setIncludeTaxes(val);
    setInteractionsSelected({ ...interactionsSelected, taxesAndFees: true });
    if (!isFilterUpdate) {
      /*** if user interact with filter */
      setIsFilterUpdated(true);
    }
  };

  const onUpdateCurrency = (curr: string): void => {
    setCurrCurrency(curr);
    setInteractionsSelected({ ...interactionsSelected, currencyConversion: true });
  };

  useEffect(() => {
    setCurrFilterData(filterData);
  }, [filterData]);

  const isActive =
    (searchQueryState[SearchFacetsList.points] &&
      Object.keys(searchQueryState[SearchFacetsList.points] ?? {}).length) ||
    searchQueryState.currentCurrency !== DefaultValue;

  return (
    <PortalStyleProvider>
      <StyledPointsModalDiv ref={setContainerRef}>
        <Button
          buttonCopy={jsonContent.pointsLabel ?? 'Points'}
          callback={(): void => {
            setCurrFilterData(undefined);
            setPopupOpenState(!popupOpenState);
            setFilterSelectionData(getSearchFilterInitialState(searchQueryState));
          }}
          className={clsx(
            'm-button-primary-inverse t-label-alt-m button-secondary filter-option-button custom_click_track sm-search-result-all-filter-component-button',
            isActive ? 'active' : ''
          )}
          custom_click_track_value={`${clickTrackingLoc}| Filter Selection: Points |internal`}
        ></Button>

        {/* TODO - remove old markup after unit testing on environment */}
        {/* <button
          type="button"
          onClick={(): void => {
            setPopupOpenState(!popupOpenState);
          }}
          className={
            't-label-alt-m filter-option-button custom_click_track sm-search-result-all-filter-component-button ' +
            (isActive ? 'active' : '')
          }
          custom_click_track_value={`${clickTrackingLoc}| Filter Selection: Points |internal`}
        >
          {jsonContent.pointsLabel ?? 'Points'}
        </button> */}
        {popupOpenState && (
          <Modal
            className={`custom-scrollbar  ${popupOpenState ? '' : 'close-popup-header'}`}
            show={true}
            handleBlur={true}
            role="dialog"
            popupOpenState={popupOpenState}
            setPopupOpenState={setPopupOpenState}
            allFilterPopUp={true}
            onClose={(): void => {
              setCurrFilterData(undefined);
            }}
            labelledBy="ModalPopup"
            modalId="ModalPopup"
            flexLayout={true}
            usePortal={true}
          >
            <Modal.Header
              // labelIcon=""
              labelText={jsonContent?.pointsLabel ?? 'Points'}
              // cancelLabel=""
              popupHeaderOnCLoseFunc={setPopupOpenState}
              customHeadingClass={isDesktop ? 't-subtitle-xl' : 't-subtitle-l'}
              flexLayout={true}
            >
              <div className="filter-by-title">{jsonContent?.pointsLabel}</div>
            </Modal.Header>
            <Modal.Body className="custom-scrollbar" flexLayout={true}>
              <PointsFilter
                allFilterPopUp={false}
                clearFilterState={filterSelectionData}
                onItemSelect={onFilterChange}
                onIncludeTaxesChange={onUpdateIncludeTax}
                onCurrencyUpdate={onUpdateCurrency}
                hideTaxesToggle={hideTaxesToggle}
                itemList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.points)[0]}
              />
            </Modal.Body>
            <Modal.Footer
              popupHeaderOnCLoseFunc={setPopupOpenState}
              clearClickHandler={(): void => {
                setCurrFilterData(undefined);
                setIncludeTaxes(false);
                setInteractionsSelected({ ...interactionsSelected, taxesAndFees: true });
                setFilterSelectionData(filterSelectionData === undefined ? null : undefined);
              }}
              applyBtnClickHandler={applyBtnHandler}
              clearButtonLabel={jsonContent.clearLabel}
              applyLabel={jsonContent.applyLabel}
              setFeatureSelected={setFeatureSelected}
              clickTrackingLoc={clickTrackingLoc}
              className={'pop-up-footer'}
              flexLayout={true}
            />
          </Modal>
        )}
      </StyledPointsModalDiv>
    </PortalStyleProvider>
  );
};
